import React, { useEffect, useState } from 'react';
import Button from '../../../components/Button/Button';
import InputForm from '../../../components/InputForm/InputForm';
import MuiTable from '../../../components/MuiTable/MuiTable';
import { updateFlashBar, updateIsLoading } from '../../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import instance from '../../../service/axiosInstane';
import { flashBarTheme } from '../../../config/flashBar';
import { StateProps } from '../../../redux/reducer';
import qs from 'qs';
import Dailog from '../../../components/Dailog/Dailog';
import Input from '../../../components/Input/Input';
import { errorMessage } from '../../../config/errorsMsg';
import {
  errorMessageAutoCapitalize,
  handlingMoreCharactor,
  totalPages,
} from '../../../config/helpers';
import { SortOrderType } from '../../../config/enum';
import SearchInput from '../../../components/SearchInput/SearchInput';
import { successMessage } from '../../../config/keyword';
import EllipsisHanlder from '../../../components/Ellipsis/EllipsisHanlder';

type RequestProps = {
  categoryId: string;
  organizationId: string;
  page: number;
  pageSize: number;
  searchText: string;
  sortBy: string;
  sortOrder: string;
};

type ResultProps = {
  id: string;
  text: string;
  organizationId: string;
  categoryId: string;
  createdDate: string;
};

const Keywords = (props: any) => {
  console.log(props, 'props');
  const dispatch = useDispatch();
  const userInfo = useSelector(
    (state: StateProps) => state.tokenInfo.userInfo.organizationId
  );
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [keywords, setKeywords] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [keywordId, setKeywordId] = useState('');
  const [formError, setFormError] = useState<any>({});
  const [requestState, setRequestState] = useState<RequestProps>({
    categoryId: props?.categoryId,
    organizationId: userInfo,
    page: page,
    pageSize: limit,
    searchText: '',
    sortBy: '',
    sortOrder: SortOrderType.ASC,
  });
  const [addKeyword, setAddKeyword] = useState<{ text: string }>({ text: '' });
  const { text } = addKeyword;

  const columns = [
    { id: 'text', label: 'keywords', minWidth: 500, align: 'left' },
    { id: 'createdDate', label: 'Created Date', minWidth: 100, align: 'left' },
    { id: 'action', label: 'Action', minWidth: 0, align: 'right' },
  ];

  useEffect(() => {
    getAllKeywords(requestState);
  }, []);

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      onAddKeywords();
    }
  }, [formError]);

  const onSearchHanlder = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRequestState({ ...requestState, searchText: e.target.value });
  };

  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchHandler();
    }
  };

  const searchHandler = () => {
    getAllKeywords({
      ...requestState,
      searchText: requestState.searchText,
      pageSize: limit,
      page: 1,
    });
    setPage(1);
  };

  const onClearSearch = () => {
    setRequestState({
      ...requestState,
      searchText: '',
      page: page,
      pageSize: limit,
    });
    getAllKeywords({
      ...requestState,
      searchText: '',
      page: page,
      pageSize: limit,
    });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAddKeyword({ ...addKeyword, [event.target.name]: event.target.value });

    if (event.target.value !== '') {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} is required`,
      });
    }
  };

  const onSubmit = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const onCancel = () => {
    setIsFormOpen(false);
    setIsSubmit(false);
    setFormError({});
    setAddKeyword({ ...addKeyword, text: '' });
  };

  const deleteRecord = (row: ResultProps) => {
    setKeywordId(row.id);
    setIsDeletePopup(true);
    setIsFormOpen(false);
  };

  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getAllKeywords({
        ...requestState,
        page: page,
        pageSize: limit,
        sortBy: requestState.sortBy,
        sortOrder: requestState.sortOrder,
      });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getAllKeywords({
          ...requestState,
          page: page + 1,
          pageSize: limit,
          sortBy: requestState.sortBy,
          sortOrder: requestState.sortOrder,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getAllKeywords({
          ...requestState,
          page: page - 1,
          pageSize: limit,
          sortBy: requestState.sortBy,
          sortOrder: requestState.sortOrder,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getAllKeywords({
          ...requestState,
          page: 1,
          pageSize: limit,
          sortBy: requestState.sortBy,
          sortOrder: requestState.sortOrder,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getAllKeywords({
          ...requestState,
          page: totalPages(totalRowCount, limit),
          pageSize: limit,
          sortBy: requestState.sortBy,
          sortOrder: requestState.sortOrder,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getAllKeywords({
        ...requestState,
        page: 1,
        pageSize: item,
        sortBy: requestState.sortBy,
        sortOrder: requestState.sortOrder,
      });
      setLimit(item);
      setPage(1);
    },
  };

  const sorting = (sortOrder: string) => {
    let temp = '';
    if (sortOrder == SortOrderType.DESC) {
      temp = SortOrderType.ASC;
    } else {
      temp = SortOrderType.DESC;
    }
    setRequestState({ ...requestState, sortOrder: temp });
    return temp;
  };

  const sortRecord = (fieldName: string, sortOrder: string) => {
    getAllKeywords({
      ...requestState,
      sortOrder: sorting(sortOrder),
      sortBy: fieldName,
      page: page,
      pageSize: limit,
    });
    setRequestState({
      ...requestState,
      sortBy: fieldName,
      sortOrder: sorting(sortOrder),
    });
  };

  const validation = () => {
    const error: any = {};
    if (!text) {
      error.addKeyword = errorMessage.emptyKeyword;
    } else if (text.length < 2 || text.length > 500) {
      error.addKeyword = errorMessage.keywordLength;
    }
    return error;
  };

  const gotResponse = (data: any) => {
    if (data?.results === null) {
      setKeywords([]);
    } else {
      setKeywords(data.results);
      setTotalRowCount(data.totalCount);
      setIsSubmit(false);
    }
    dispatch(updateIsLoading(false));
  };

  const getAllKeywords = (obj: RequestProps) => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `/keywords?${queryString}`;
    instance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const onAddKeywords = async () => {
    const obj = {
      text: text,
      categoryId: props.categoryId,
    };
    dispatch(updateIsLoading(true));
    await instance
      .post('/keywords', obj)
      .then((response) => {
        if (response.status === 201) {
          setIsFormOpen(false);
          const obj = {
            isOpen: true,
            message: successMessage.KEYWORD_ADD,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          getAllKeywords({
            ...requestState,
            page: page,
            pageSize: limit,
            sortBy: '',
          });
          setAddKeyword({ ...addKeyword, text: '' });
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        const obj = {
          isOpen: true,
          message: err.response.data.Message
            ? err.response.data.Message
            : errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const deleteKeyword = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .delete(`/keywords/${keywordId}`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.KEYWORD_DELETE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          dispatch(updateIsLoading(false));
          setIsDeletePopup(false);
          getAllKeywords({
            ...requestState,
            page: 1,
            pageSize: limit,
          });
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  return (
    <>
      <div className="px-2 py-1">
        <div className="bg-white p-2 rounded-sm sm:w-full lg:flex items-center justify-between space-x-2">
          <SearchInput
            value={requestState.searchText}
            onChange={onSearchHanlder}
            onSearch={searchHandler}
            onClear={() => onClearSearch()}
            handleEnterKeyPress={handleEnterKeyPress}
          />
          <div className="w-full">
            <div>
              <EllipsisHanlder
                word={props.category?.name}
                NoOfChar={20}
                label={'Category'}
              />
            </div>
          </div>
          <div className="w-full relative">
            <div>
              <EllipsisHanlder
                word={props.category?.categoryLabelName}
                NoOfChar={20}
                label={'Category Label'}
              />
            </div>
          </div>
          {props.isActive && (
            <div className="sm:flex items-center">
              <Button
                label="Add"
                type="button"
                buttonType="primary"
                icon={<i className="fa-solid fa-plus"></i>}
                onClick={() => setIsFormOpen(!isFormOpen)}
              />
            </div>
          )}
        </div>
        <InputForm
          title={'Add New Keyword'}
          isFormOpen={isFormOpen}
          onSubmit={onSubmit}
          onCancel={onCancel}
        >
          <div className="lg:flex items-center justify-between">
            <Input
              name={'text'}
              type={'text'}
              label={'Keyword'}
              value={text}
              placeholder={`Enter Keyword`}
              onChange={handleChange}
              error={formError?.addKeyword}
            />
          </div>
        </InputForm>
        <MuiTable
          columns={columns}
          rows={keywords}
          page={page}
          limit={limit}
          paginateHandler={paginateHandler}
          totalRowCount={totalRowCount}
          onSortHandler={sortRecord}
          sortOrder={requestState.sortOrder}
          checkBoxShow={false}
          showDelete={true}
          onDeleteHandler={deleteRecord}
          showView={false}
        />
      </div>
      <div className="flex justify-center pt-8">
        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          title={'Keyword'}
          onConfirm={deleteKeyword}
        />
      </div>
    </>
  );
};

export default Keywords;
